<template>

  <div class="">
    <template v-for="wallet in wallets">
      <div
          class="radio-option mx-2 d-inline-block"
          :class="{ active: (selectedWallet ==wallet.id && gate == 'wallet') }"
          @click="emitGateId('wallet',wallet.id)">

        <img class="d-block option-image-radio-box mb-2 img-fluid"
             :src="walletImage"
             alt="wallet-image">
        <span class="d-block">
        {{ wallet.name }}
        <br>
        <span>{{ formatNumber(wallet.value) }} تومان</span>
      </span>
      </div>
    </template>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import walletImage from '../images/wallet.png'

export default {
  name: "GateWalletManager1",
  props: {
    requiredInputs: {},
    gate: {
      default: null
    },
    requestMode: {
      default: 'normal',
    }
  },
  data() {
    return {
      walletImage,
      wallets: [],
      selectedWallet: null
    }
  },
  computed: {
    ...mapGetters({
      profile: "User/getProfile",
      isAuth: "User/isAuthenticated"
    }),
  },
  methods: {
    formatNumber,
    async getUserWallets() {
      let form = {
        user_id: this.profile.id,
        page: 1
      }

      let req;
      if (this.requestMode == 'normal') {
        req = await this.$store.dispatch('Wallet/getWallets', form)
      } else {
        req = await this.$store.dispatch('DashboardSubscription/getWallets', form)
      }

      this.wallets = req.data.data.data
    },
    emitGateId(value, wallet_id) {
      this.selectedWallet = wallet_id
      this.$emit('input', value)
      this.$emit('wallet_id', wallet_id)
    }
  },
  mounted() {
    if (this.isAuth) {
      this.getUserWallets()
    }
  }
}
</script>

<style scoped>

</style>